module.exports = __webpack_public_path__ + "img/black-tea.339251bf.svg";